import { render, staticRenderFns } from "./login_modal.vue?vue&type=template&id=2c056594&"
import script from "./login_modal.vue?vue&type=script&lang=js&"
export * from "./login_modal.vue?vue&type=script&lang=js&"
import style0 from "./login_modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports